export const FULL_MENU_WIDTH = 240
export const COMPACT_MENU_WIDTH = 76
